// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import type { ReportRunSpec } from '../../api/client'

export type SelCol = { fieldId: number; agg: string }
export type SelFilter = { fieldId: number; op: string; value: string }

export interface SpecArgs {
  pharmacyId: string
  columns: SelCol[]
  filters: SelFilter[]
  computed?: string[]
  groupBy?: number[]
  previewRole?: string | null
  rowCap?: number
}

/**
 * Pure builder for the report run spec sent to POST /reports/run. Kept out of the
 * component so it can be unit-tested without a DOM: drops blank filters, maps the
 * selected columns/aggregates/computed, omits pharmacyId when none is chosen, and
 * only sends previewRole when previewing as a non-default role.
 */
export function buildReportSpec(args: SpecArgs): ReportRunSpec {
  const { pharmacyId, columns, filters, computed = [], groupBy = [], previewRole, rowCap = 1000 } = args
  const spec: ReportRunSpec = {
    pharmacyId: pharmacyId || undefined,
    rowCap,
    columns: columns.map(c => ({ fieldId: c.fieldId, agg: c.agg })),
    filters: filters
      .filter(f => f.value.trim() !== '')
      .map(f => ({ fieldId: f.fieldId, op: f.op, value: f.value })),
  }
  if (computed.length) spec.computed = computed
  if (groupBy.length) spec.groupBy = groupBy
  if (previewRole && previewRole !== 'Super-admin (you)') spec.previewRole = previewRole
  return spec
}
